import { Provider } from "@redotech/redo-model/order";
import * as z from "zod/v4";

export const searchProductTags = {
  name: "searchProductTags" as const,
  input: z.object({ searchString: z.string(), provider: z.enum(Provider) }),
  output: z.object({ tags: z.array(z.string()) }),
};
